import React from "react"
export const VehicleMaintenanceDetailContext = React.createContext(null);

export const useVehicleMaintenanceDetailContext = () => {

const context = React.useContext(VehicleMaintenanceDetailContext);

if (!context) throw new Error("VehicleMaintenance Detail Context not provided!");

return context;
}